export const TRANSLATE_PREFIX = 'STATIC.PAGES.PARTNERS_INTEGRATION';

export const WHITESPACE_REGEX = /\s/;

// Valid URL query parameter name: RFC 3986 unreserved characters only. Empty string allowed (drafts).
export const URL_QUERY_KEY_REGEX = /^[A-Za-z0-9_\-.~]*$/;

// Client-side guard for URL query parameter values (e.g. partner_macro).
// Rejects whitespace and the characters that would break URL/HTML contexts. Empty string allowed (drafts).
export const URL_QUERY_VALUE_REGEX = /^[^<>"'&=#\\\s]*$/;

export const REQUEST_TYPES = {
    ANALYTICS: 'analytics',
    ATTRIBUTION: 'attribution',
    AD_MONETIZATION: 'ad_monetization',
    AUDIENCE: 'audience',
};

export const REQUEST_TYPE_LABELS = {
    [REQUEST_TYPES.ANALYTICS]: `${TRANSLATE_PREFIX}.CARDS.ANALYTICS_TITLE`,
    [REQUEST_TYPES.ATTRIBUTION]: `${TRANSLATE_PREFIX}.CARDS.ATTRIBUTION_TITLE`,
    [REQUEST_TYPES.AD_MONETIZATION]: `${TRANSLATE_PREFIX}.CARDS.AD_MONETIZATION_TITLE`,
    [REQUEST_TYPES.AUDIENCE]: `${TRANSLATE_PREFIX}.CARDS.AUDIENCE_TITLE`,
};

export const STATUSES = {
    NOT_STARTED: 'not_started',
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    IN_REVIEW: 'in_review',
    APPROVED: 'approved',
    ARCHIVED: 'archived',
    REJECTED: 'rejected',
    DELETED: 'deleted',
};

export const INTEGRATION_CARDS = [
    {
        type: REQUEST_TYPES.ATTRIBUTION,
        titleKey: `${TRANSLATE_PREFIX}.CARDS.ATTRIBUTION_TITLE`,
        descriptionKey: `${TRANSLATE_PREFIX}.CARDS.ATTRIBUTION_DESCRIPTION`,
    },
    {
        type: REQUEST_TYPES.ANALYTICS,
        titleKey: `${TRANSLATE_PREFIX}.CARDS.ANALYTICS_TITLE`,
        descriptionKey: `${TRANSLATE_PREFIX}.CARDS.ANALYTICS_DESCRIPTION`,
    },
    {
        type: REQUEST_TYPES.AD_MONETIZATION,
        titleKey: `${TRANSLATE_PREFIX}.CARDS.AD_MONETIZATION_TITLE`,
        descriptionKey: `${TRANSLATE_PREFIX}.CARDS.AD_MONETIZATION_DESCRIPTION`,
    },
    {
        type: REQUEST_TYPES.AUDIENCE,
        titleKey: `${TRANSLATE_PREFIX}.CARDS.AUDIENCE_TITLE`,
        descriptionKey: `${TRANSLATE_PREFIX}.CARDS.AUDIENCE_DESCRIPTION`,
    },
];

export const STATUS_LABEL_KEYS = {
    [STATUSES.NOT_STARTED]: `${TRANSLATE_PREFIX}.STATUSES.NOT_STARTED`,
    [STATUSES.DRAFT]: `${TRANSLATE_PREFIX}.STATUSES.DRAFT`,
    [STATUSES.SUBMITTED]: `${TRANSLATE_PREFIX}.STATUSES.PENDING_REVIEW`,
    [STATUSES.IN_REVIEW]: `${TRANSLATE_PREFIX}.STATUSES.PENDING_REVIEW`,
    [STATUSES.APPROVED]: `${TRANSLATE_PREFIX}.STATUSES.LIVE`,
    [STATUSES.REJECTED]: `${TRANSLATE_PREFIX}.STATUSES.REJECTED`,
    [STATUSES.ARCHIVED]: `${TRANSLATE_PREFIX}.STATUSES.ARCHIVED`,
    [STATUSES.DELETED]: `${TRANSLATE_PREFIX}.STATUSES.DELETED`,
};

export const FORM_TYPES = [REQUEST_TYPES.ATTRIBUTION];
export const DISABLED_REASONS = {
    PROFILE_INCOMPLETE: 'profile_incomplete',
};

export const ADMIN_EDITABLE_STATUSES = [STATUSES.SUBMITTED, STATUSES.IN_REVIEW];
export const INACTIVE_REQUEST_STATUSES = [STATUSES.REJECTED, STATUSES.DELETED, STATUSES.ARCHIVED];
export const HIDDEN_STATUSES = [STATUSES.DELETED, STATUSES.ARCHIVED];
export const READ_ONLY_STATUSES = [
    STATUSES.SUBMITTED,
    STATUSES.IN_REVIEW,
    STATUSES.APPROVED,
    STATUSES.REJECTED,
    STATUSES.ARCHIVED,
    STATUSES.DELETED,
];
export const TEMPLATE_DOWNLOADABLE_STATUSES = [
    STATUSES.DRAFT,
    STATUSES.SUBMITTED,
    STATUSES.IN_REVIEW,
    STATUSES.APPROVED,
];

export const ATTRIBUTION_TAB_IDS = {
    GENERAL: 'general',
    TRACKING_LINK_OPTIONS: 'tracking_link_options',
    POSTBACK_OVERALL_SETUP: 'postback_overall_setup',
    POSTBACK_TEMPLATES: 'platform_templates',
};

export const FORM_TABS = {
    [REQUEST_TYPES.ATTRIBUTION]: [
        { id: ATTRIBUTION_TAB_IDS.GENERAL, label: `${TRANSLATE_PREFIX}.TABS.GENERAL` },
        { id: ATTRIBUTION_TAB_IDS.TRACKING_LINK_OPTIONS, label: `${TRANSLATE_PREFIX}.TABS.TRACKING_LINK_OPTIONS` },
        { id: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP, label: `${TRANSLATE_PREFIX}.TABS.POSTBACK_OVERALL_SETUP` },
        { id: ATTRIBUTION_TAB_IDS.POSTBACK_TEMPLATES, label: `${TRANSLATE_PREFIX}.TABS.POSTBACK_TEMPLATES` },
    ],
};

export const FORM_INFO_GUIDES = {
    [REQUEST_TYPES.ATTRIBUTION]: {
        introKey: `${TRANSLATE_PREFIX}.GUIDES.ATTRIBUTION.INTRO`,
        sections: [
            {
                titleKey: `${TRANSLATE_PREFIX}.GUIDES.ATTRIBUTION.TRACKING_LINKS_TITLE`,
                descriptionKey: `${TRANSLATE_PREFIX}.GUIDES.ATTRIBUTION.TRACKING_LINKS_DESCRIPTION`,
            },
            {
                titleKey: `${TRANSLATE_PREFIX}.GUIDES.ATTRIBUTION.POSTBACK_TITLE`,
                descriptionKey: `${TRANSLATE_PREFIX}.GUIDES.ATTRIBUTION.POSTBACK_DESCRIPTION`,
            },
        ],
    },
};

export const PLATFORM_TEMPLATES = {
    NONE: 'none',
    HASOFFERS: 'hasoffers',
    AFFISE: 'affise',
    EVERFLOW: 'everflow',
};

export const PLATFORM_TEMPLATE_OPTIONS = [
    { value: PLATFORM_TEMPLATES.NONE, labelKey: `${TRANSLATE_PREFIX}.PLATFORM_TEMPLATES.NONE` },
    { value: PLATFORM_TEMPLATES.HASOFFERS, labelKey: `${TRANSLATE_PREFIX}.PLATFORM_TEMPLATES.HASOFFERS` },
    { value: PLATFORM_TEMPLATES.AFFISE, labelKey: `${TRANSLATE_PREFIX}.PLATFORM_TEMPLATES.AFFISE` },
    { value: PLATFORM_TEMPLATES.EVERFLOW, labelKey: `${TRANSLATE_PREFIX}.PLATFORM_TEMPLATES.EVERFLOW` },
];

export const PARTNERS_INFORMATION_FEATURE_NAME = 'partners_information';

export const PLATFORMS = {
    IOS: 'ios',
    ANDROID: 'android',
    WEB: 'web',
    CTV: 'ctv',
    PC: 'pc',
    CONSOLE: 'pcconsole',
    OTHER: 'other',
};

export const POSTBACK_PLATFORM_OPTION = [
    PLATFORMS.IOS,
    PLATFORMS.ANDROID,
    PLATFORMS.WEB,
    PLATFORMS.PC,
    PLATFORMS.CONSOLE,
];
export const PLATFORM_OPTIONS = [...POSTBACK_PLATFORM_OPTION, PLATFORMS.CTV, PLATFORMS.OTHER];

/** General-tab platforms that require a filled IP partner macro in tracking link options on submit. */
/** ``general.platforms`` values that enable extra tracking-link validation (backend ``TRACKING_LINK_EXTRA_RULE_PLATFORMS``). */
export const TRACKING_LINK_EXTRA_RULE_PLATFORMS = [PLATFORMS.WEB, PLATFORMS.PC, PLATFORMS.CONSOLE];

export const generalPlatformsIncludeTrackingLinkExtraRulePlatform = platforms =>
    Array.isArray(platforms) && platforms.some(p => TRACKING_LINK_EXTRA_RULE_PLATFORMS.includes(p));

export const CAMPAIGN_OBJECTIVES = {
    INSTALLS: 'installs',
    RE_ENGAGEMENTS: 're-engagements',
    IN_APP_EVENTS: 'in-app_events',
    WEB_TRAFFIC: 'web_traffic',
    PRE_ACTIVATED_INSTALL_PRELOAD: 'pre-activated_install_preload',
};

export const CAMPAIGN_OBJECTIVE_OPTIONS = [
    CAMPAIGN_OBJECTIVES.INSTALLS,
    CAMPAIGN_OBJECTIVES.RE_ENGAGEMENTS,
    CAMPAIGN_OBJECTIVES.IN_APP_EVENTS,
    CAMPAIGN_OBJECTIVES.WEB_TRAFFIC,
    CAMPAIGN_OBJECTIVES.PRE_ACTIVATED_INSTALL_PRELOAD,
];

export const DATA_SCOPES = {
    ATTRIBUTED_ONLY: 'attributed_only',
    ALL_INSTALLS: 'all_installs',
    ALL_EVENTS: 'all_events',
};

export const DATA_SCOPE_INSTALLS_OPTIONS = [DATA_SCOPES.ATTRIBUTED_ONLY, DATA_SCOPES.ALL_INSTALLS];
export const DATA_SCOPE_EVENTS_OPTIONS = [DATA_SCOPES.ATTRIBUTED_ONLY, DATA_SCOPES.ALL_EVENTS];

export const CLICK_IMPRESSION_REPORTING_METHODS = {
    CLIENT_SIDE: 'client_side',
    SERVER_SIDE: 'server_side',
    BOTH: 'both',
};

export const CLICK_IMPRESSION_REPORTING_METHOD_OPTIONS = [
    CLICK_IMPRESSION_REPORTING_METHODS.CLIENT_SIDE,
    CLICK_IMPRESSION_REPORTING_METHODS.SERVER_SIDE,
    CLICK_IMPRESSION_REPORTING_METHODS.BOTH,
];

export const POSTBACK_METHODS = {
    GET: 'GET',
    POST: 'POST',
};

export const POSTBACK_METHOD_OPTIONS = [POSTBACK_METHODS.GET, POSTBACK_METHODS.POST];

export const POSTBACK_EVENT_TYPES = {
    CONVERSIONS: 'conversions',
    POST_INSTALL_EVENTS: 'post_install_events',
    REVENUE_EVENTS: 'revenue_events',
    FRAUD_POSTBACKS: 'fraud_postbacks',
};

export const POSTBACK_EVENT_TYPE_OPTIONS = [
    POSTBACK_EVENT_TYPES.CONVERSIONS,
    POSTBACK_EVENT_TYPES.POST_INSTALL_EVENTS,
    POSTBACK_EVENT_TYPES.REVENUE_EVENTS,
    POSTBACK_EVENT_TYPES.FRAUD_POSTBACKS,
];

export const urlField = eventType => `${eventType}_postback_url`;

// Event mapping (enable_event_mapping) is only applicable to these event types.
export const EVENT_MAPPING_EVENT_TYPES = [
    POSTBACK_EVENT_TYPES.POST_INSTALL_EVENTS,
    POSTBACK_EVENT_TYPES.REVENUE_EVENTS,
];

/**
 * UI-only mapping: when the user toggles a campaign objective ON in the General tab, the listed
 * postback event types are auto-added to `postback_events_and_platforms` for the platforms the user
 * has currently selected. Values are arrays so a single objective can pre-select multiple event
 * types in the future. Frontend default-fill only — there is no backend rule enforcing this.
 */
export const CAMPAIGN_OBJECTIVE_TO_POSTBACK_EVENTS = {
    [CAMPAIGN_OBJECTIVES.IN_APP_EVENTS]: [POSTBACK_EVENT_TYPES.POST_INSTALL_EVENTS],
};

/** Placeholder literal in macro templates; replaced with partner AdNetwork.apsalar_name (must match backend). */
export const POSTBACK_MACRO_NETWORK_PLACEHOLDER = 'NetworkName';

/**
 * @param {string} template macro string that may contain the placeholder
 * @param {string} [postbackMacroNetworkName] partner postback macro network name; if missing or blank, template is unchanged
 * @returns {string} same macro with every placeholder occurrence replaced by the suffix, or the original template
 */
export const substitutePostbackNetworkName = (template, postbackMacroNetworkName) => {
    const p = (postbackMacroNetworkName || '').trim();
    if (!p) return template;
    return template.split(POSTBACK_MACRO_NETWORK_PLACEHOLDER).join(p);
};

/**
 * @param {string} singularKey tracking-link parameter key
 * @param {string} postbackMacroNetworkName partner AdNetwork.apsalar_name
 * @returns {string} macro string for postback templates
 */
export const buildPassthroughAdnetworkMacro = (singularKey, postbackMacroNetworkName) =>
    substitutePostbackNetworkName(`{${singularKey}?${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}`, postbackMacroNetworkName);

const _ALL_POSTBACK_PLATFORMS = Object.freeze([
    PLATFORMS.IOS,
    PLATFORMS.ANDROID,
    PLATFORMS.WEB,
    PLATFORMS.PC,
    PLATFORMS.CONSOLE,
]);
const _IOS_ONLY = Object.freeze([PLATFORMS.IOS]);
const _ANDROID_ONLY = Object.freeze([PLATFORMS.ANDROID]);

/**
 * Postback singular_macro catalog with per-macro allowed-platform sets.
 * Each entry: [macroTemplate, allowedPlatforms]. Mirrors the backend
 * POSTBACK_SINGULAR_MACRO_PLATFORMS in integration_request_consts.py.
 *
 * Note: passthrough macros `{<key>?<network>}` are NOT in this list — they're added dynamically
 * from filled tracking-link parameters (see PostbackTemplateMacroTable.passthroughMacros).
 */
const POSTBACK_SINGULAR_MACRO_PLATFORMS = Object.freeze([
    // Device-Related Macros
    ['{PLATFORM}', _ALL_POSTBACK_PLATFORMS],
    ['{IDFA}', _IOS_ONLY],
    ['{AIFA}', _ANDROID_ONLY],
    // Application Macros
    ['{APP_NAME}', _ALL_POSTBACK_PLATFORMS],
    ['{LONGNAME}', _ALL_POSTBACK_PLATFORMS],
    ['{PUBLIC_ID}', _IOS_ONLY],
    // Campaign Macros
    [`{NETWORK=${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}`, _ALL_POSTBACK_PLATFORMS],
    // Assists Macros
    [`{IS_SINGLE_ATTRIBUTED=${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}`, _ALL_POSTBACK_PLATFORMS],
    [`{IS_ASSIST=${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}`, _ALL_POSTBACK_PLATFORMS],
    // Campaign Macros (continued)
    ['{IS_RE_ENG}', _ALL_POSTBACK_PLATFORMS],
    ['{IS_VIEWTHROUGH}', _ALL_POSTBACK_PLATFORMS],
    // Device-Related Macros
    ['{DNT}', _ALL_POSTBACK_PLATFORMS],
    ['{NODNT}', _ALL_POSTBACK_PLATFORMS],
    ['{MATCH_TYPE}', _ANDROID_ONLY],
    ['{ATTRIBUTION_WINDOW}', _ALL_POSTBACK_PLATFORMS],
    ['{TOUCHPOINT_IP}', _ALL_POSTBACK_PLATFORMS],
    ['{ATTRIBUTION_IP}', _ALL_POSTBACK_PLATFORMS],
    ['{EVENT_IP}', _ALL_POSTBACK_PLATFORMS],
    ['{TOUCHPOINT_COUNTRY}', _ALL_POSTBACK_PLATFORMS],
    ['{ATTRIBUTION_COUNTRY}', _ALL_POSTBACK_PLATFORMS],
    ['{EVENT_COUNTRY}', _ALL_POSTBACK_PLATFORMS],
    ['{TOUCHPOINT_CITY}', _ALL_POSTBACK_PLATFORMS],
    ['{ATTRIBUTION_CITY}', _ALL_POSTBACK_PLATFORMS],
    ['{EVENT_CITY}', _ALL_POSTBACK_PLATFORMS],
    ['{TOUCHPOINT_STATE}', _ALL_POSTBACK_PLATFORMS],
    ['{ATTRIBUTION_STATE}', _ALL_POSTBACK_PLATFORMS],
    ['{EVENT_STATE}', _ALL_POSTBACK_PLATFORMS],
    ['{OS_VERSION}', _ALL_POSTBACK_PLATFORMS],
    ['{APP_VERSION}', _ALL_POSTBACK_PLATFORMS],
    ['{IFA1}', _IOS_ONLY],
    ['{IFA5}', _IOS_ONLY],
    ['{IDFV}', _IOS_ONLY],
    ['{AIF1}', _ANDROID_ONLY],
    ['{AIF5}', _ANDROID_ONLY],
    ['{OAI1}', _ANDROID_ONLY],
    ['{OAI5}', _ANDROID_ONLY],
    ['{AMI1}', _ANDROID_ONLY],
    ['{AMI5}', _ANDROID_ONLY],
    ['{ASID}', _ANDROID_ONLY],
    ['{DEVICE_MODEL}', _ALL_POSTBACK_PLATFORMS],
    ['{DEVICE_BRAND}', _ALL_POSTBACK_PLATFORMS],
    ['{USER_AGENT}', _ALL_POSTBACK_PLATFORMS],
    ['{ATT_AUTHORIZATION_STATUS}', _IOS_ONLY],
    ['{ATT_NAME}', _IOS_ONLY],
    ['{INSTALLER_SOURCE}', _ANDROID_ONLY],
    ['{APPSTORE_FLAG}', _ANDROID_ONLY],
    // Event Macros
    ['{AMOUNT}', _ALL_POSTBACK_PLATFORMS],
    ['{RAW_AMOUNT}', _ALL_POSTBACK_PLATFORMS],
    ['{ORIGINAL_REVENUE}', _ALL_POSTBACK_PLATFORMS],
    ['{CONVERTED_REVENUE}', _ALL_POSTBACK_PLATFORMS],
    ['{CURRENCY}', _ALL_POSTBACK_PLATFORMS],
    ['{IAP_RECEIVED_EVENT_NAME}', _ALL_POSTBACK_PLATFORMS],
    ['{IAP_RECEIVED_REVENUE}', _ALL_POSTBACK_PLATFORMS],
    ['{IAP_RECEIPT_RECEIVED}', _ALL_POSTBACK_PLATFORMS],
    ['{IAP_RECEIPT_VALID}', _ALL_POSTBACK_PLATFORMS],
    ['{IS_FIRST_EVENT}', _ALL_POSTBACK_PLATFORMS],
    ['{EVTNAME}', _ALL_POSTBACK_PLATFORMS],
    ['{EVTATTRS}', _ALL_POSTBACK_PLATFORMS],
    // Time Macros
    ['{DATE}', _ALL_POSTBACK_PLATFORMS],
    ['{TIME}', _ALL_POSTBACK_PLATFORMS],
    ['{UTC}', _ALL_POSTBACK_PLATFORMS],
    ['{UTCM}', _ALL_POSTBACK_PLATFORMS],
    ['{CLICK_UTC}', _ALL_POSTBACK_PLATFORMS],
    ['{CLICK_UTCM}', _ALL_POSTBACK_PLATFORMS],
    ['{CLICK_TIME}', _ALL_POSTBACK_PLATFORMS],
    ['{CLICK_DATE}', _ALL_POSTBACK_PLATFORMS],
    ['{INSTALL_UTC}', _ALL_POSTBACK_PLATFORMS],
    ['{INSTALL_UTCM}', _ALL_POSTBACK_PLATFORMS],
    ['{INSTALL_TIME}', _ALL_POSTBACK_PLATFORMS],
    ['{INSTALL_DATE}', _ALL_POSTBACK_PLATFORMS],
    // Device-Related Macros
    ['{GLOBAL_PROPERTIES}', _ALL_POSTBACK_PLATFORMS],
    // Other Macros
    ['{RAND}', _ALL_POSTBACK_PLATFORMS],
    ['{JSON}', _ALL_POSTBACK_PLATFORMS],
    ['{POST}', _ALL_POSTBACK_PLATFORMS],
    ['{FRAUD_REASON_EXTERNAL}', _ALL_POSTBACK_PLATFORMS],
    // Third-Party Analytics Macros
    ['{CID}', _ALL_POSTBACK_PLATFORMS],
]);

/**
 * Resolved selectable postback macros for a partner, optionally filtered by template platform.
 * Mirrors backend get_postback_singular_macros.
 * @param {string} postbackMacroNetworkName partner postback macro network name (integration id token)
 * @param {?string} [platform] postback platform to filter by; null/undefined returns the full catalog
 * @returns {string[]} resolved macro strings for postback template singular_macro options
 */
export const getPostbackSingularMacros = (postbackMacroNetworkName, platform = null) =>
    POSTBACK_SINGULAR_MACRO_PLATFORMS.filter(
        ([, allowed]) => platform === null || platform === undefined || allowed.includes(platform)
    ).map(([t]) => substitutePostbackNetworkName(t, postbackMacroNetworkName));

/**
 * Allowed-platform list for a macro template. Falls back to all postback platforms for unknown macros
 * (e.g. custom passthroughs `{x?<network>}`); call sites that need to short-circuit those should check
 * `trackingLinkKeyFromMacro` before using this helper.
 * @param {string} macro macro template (with POSTBACK_MACRO_NETWORK_PLACEHOLDER, not the resolved suffix)
 * @returns {string[]} allowed postback platforms (frozen array; do not mutate)
 */
export const getMacroAllowedPlatforms = macro => {
    if (!macro) return _ALL_POSTBACK_PLATFORMS;
    const direct = POSTBACK_SINGULAR_MACRO_PLATFORMS.find(([t]) => t === macro);
    if (direct) return direct[1];
    return _ALL_POSTBACK_PLATFORMS;
};

// Default-pinned rows in PostbackTemplateMacroTable.
// Each entry: macro template (with optional POSTBACK_MACRO_NETWORK_PLACEHOLDER), and an optional
// `eventTypes` restriction. At render time the list is intersected with the cell's platform
// (via getMacroAllowedPlatforms) and event_type, then network-substituted via getDefaultPostbackMacros.
const _DEFAULT_REVENUE_EVENTS_ONLY = Object.freeze([POSTBACK_EVENT_TYPES.REVENUE_EVENTS]);

export const DEFAULT_POSTBACK_MACROS = Object.freeze([
    { macro: '{LONGNAME}' },
    { macro: '{PUBLIC_ID}' },
    { macro: '{IDFA}' },
    { macro: '{AIFA}' },
    { macro: '{EVTNAME}' },
    { macro: '{AMOUNT}', eventTypes: _DEFAULT_REVENUE_EVENTS_ONLY },
    { macro: '{CURRENCY}', eventTypes: _DEFAULT_REVENUE_EVENTS_ONLY },
    { macro: '{UTC}' },
    { macro: `{cl?${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}` },
    { macro: `{pcrn?${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}` },
    { macro: `{pcrid?${POSTBACK_MACRO_NETWORK_PLACEHOLDER}}` },
]);

/**
 * Resolved default macro strings to pin for one (platform, eventType) cell, with network placeholder substituted.
 * @param {string} platform postback platform of the cell
 * @param {string} eventType postback event_type of the cell
 * @param {string} postbackMacroNetworkName partner postback macro network name
 * @returns {string[]} resolved macro strings to pin as default rows
 */
export const getDefaultPostbackMacros = (platform, eventType, postbackMacroNetworkName) =>
    DEFAULT_POSTBACK_MACROS.filter(({ macro, eventTypes }) => {
        if (!getMacroAllowedPlatforms(macro).includes(platform)) return false;
        if (eventTypes && !eventTypes.includes(eventType)) return false;
        return true;
    }).map(({ macro }) => substitutePostbackNetworkName(macro, postbackMacroNetworkName));

/**
 * True when `macro` matches any default macro template (post network-substitution), regardless of platform/eventType.
 * @param {string} macro resolved macro string from a saved template row
 * @param {string} postbackMacroNetworkName partner postback macro network name
 * @returns {boolean} whether the macro is one of the configured defaults
 */
export const isDefaultPostbackMacro = (macro, postbackMacroNetworkName) => {
    if (!macro) return false;
    return DEFAULT_POSTBACK_MACROS.some(
        ({ macro: template }) => substitutePostbackNetworkName(template, postbackMacroNetworkName) === macro
    );
};

// Passthrough-parameter macros: `{x?<network>}` — click value from tracking param `x`; network is the partner postback macro network name.
// Returns the tracking-link key (e.g. "cl" for "{cl?my_partner}"), or null if the macro is not a passthrough.
const TRACKING_LINK_MACRO_PATTERN = /^\{([^?{}]+)\?[^{}]+\}$/;

export const trackingLinkKeyFromMacro = macro => {
    const match = TRACKING_LINK_MACRO_PATTERN.exec(macro || '');
    return match ? match[1] : null;
};

// Postback event types each affiliate template does NOT support. Lives in consts so leaf
// modules (e.g. postbackEventsPlatformsUpdates.js) can read it without importing
// platformTemplateDefaults.js (which imports the cascade — would cause a cycle).
export const PLATFORM_TEMPLATE_DISALLOWED_EVENT_TYPES = {
    [PLATFORM_TEMPLATES.HASOFFERS]: [POSTBACK_EVENT_TYPES.FRAUD_POSTBACKS],
    [PLATFORM_TEMPLATES.EVERFLOW]: [POSTBACK_EVENT_TYPES.FRAUD_POSTBACKS],
};

// Postback singular_macros that are forbidden in specific (template, event_type) cells.
// Filtered out of the macro dropdown, never seeded by the cascade, and rejected at submit time.
export const PLATFORM_TEMPLATE_DISALLOWED_MACROS_BY_EVENT_TYPE = {
    [PLATFORM_TEMPLATES.HASOFFERS]: {
        [POSTBACK_EVENT_TYPES.CONVERSIONS]: ['{EVTNAME}'],
    },
    [PLATFORM_TEMPLATES.AFFISE]: {
        [POSTBACK_EVENT_TYPES.CONVERSIONS]: ['{EVTNAME}'],
    },
    [PLATFORM_TEMPLATES.EVERFLOW]: {
        [POSTBACK_EVENT_TYPES.CONVERSIONS]: ['{EVTNAME}'],
    },
};

export const isPostbackMacroDisallowedForCell = (template, eventType, macro) => {
    const byEvent = PLATFORM_TEMPLATE_DISALLOWED_MACROS_BY_EVENT_TYPE[template];
    return !!(byEvent && (byEvent[eventType] || []).includes(macro));
};

export const MACRO_INPUT_TYPES = {
    TEXT: 'text',
    DROPDOWN: 'dropdown',
};

export const MACRO_INPUT_TYPE_OPTIONS = [MACRO_INPUT_TYPES.TEXT, MACRO_INPUT_TYPES.DROPDOWN];

export const TRACKING_LINK_CATEGORIES = {
    ALL: 'all',
    DEVICE_LEVEL: 'device_level',
    CAMPAIGN: 'campaign',
    PUBLISHER: 'publisher',
    OTHER: 'other',
    CUSTOM: 'custom',
};

export const REQUIRED_SERVER_SIDE_MACRO_KEYS = ['ip', 'p'];

/** ``singular_key`` rows that must be filled when ``generalPlatformsIncludeTrackingLinkExtraRulePlatform`` (aligned with backend). */
export const TRACKING_LINK_EXTRA_REQUIRED_KEYS = ['ip'];

// Highly recommended for server-side / both reporting, but not strictly required.
export const RECOMMENDED_SERVER_SIDE_MACRO_KEYS = ['ua'];

export const STANDARD_TRACKING_LINK_PARAMETERS = [
    // ---- Device Level (primary) ----
    {
        singularKey: 'p',
        fieldName: 'Platform',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'ip',
        fieldName: 'IP',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'ua',
        fieldName: 'User Agent',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'pet',
        fieldName: 'Engagement Type',
        hasHelpLink: true,
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'cl',
        fieldName: 'Click ID',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 've',
        fieldName: 'OS Version',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'idfa',
        fieldName: 'IDFA',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'idfv',
        fieldName: 'IDFV',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    {
        singularKey: 'aifa',
        fieldName: 'AIFA',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: true,
    },
    // ---- Campaign (primary) ----
    {
        singularKey: 'pcn',
        fieldName: 'Campaign Name',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    {
        singularKey: 'pcid',
        fieldName: 'Campaign ID',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    {
        singularKey: 'pscn',
        fieldName: 'Sub Campaign Name',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    {
        singularKey: 'pscid',
        fieldName: 'Sub Campaign ID',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    {
        singularKey: 'pcrn',
        fieldName: 'Creative Name',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    {
        singularKey: 'pcrid',
        fieldName: 'Creative ID',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: true,
    },
    // ---- Publisher (primary) ----
    {
        singularKey: 'pshid',
        fieldName: 'Hashed Publisher ID',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: true,
    },
    {
        singularKey: 'psn',
        fieldName: 'Publisher Site Name',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: true,
    },
    {
        singularKey: 'psid',
        fieldName: 'Publisher Site ID',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: true,
    },
    {
        singularKey: 'paffn',
        fieldName: 'Affiliate Name',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: true,
    },
    {
        singularKey: 'paffid',
        fieldName: 'Affiliate ID',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: true,
    },
    // ---- Secondary macros (available via dropdown) ----
    {
        singularKey: 'amid',
        fieldName: 'AMID',
        category: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL,
        primary: false,
    },
    {
        singularKey: 'wpkwn',
        fieldName: 'Keyword',
        category: TRACKING_LINK_CATEGORIES.CAMPAIGN,
        primary: false,
    },
    {
        singularKey: 'pssn',
        fieldName: 'Placement Name',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: false,
    },
    {
        singularKey: 'pssid',
        fieldName: 'Placement ID',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: false,
    },
    {
        singularKey: 'pnetworkn',
        fieldName: 'Network Channel',
        category: TRACKING_LINK_CATEGORIES.PUBLISHER,
        primary: false,
    },
    {
        singularKey: 'gid',
        fieldName: 'Goal ID',
        category: TRACKING_LINK_CATEGORIES.OTHER,
        primary: false,
    },
    {
        singularKey: 'impressionid',
        fieldName: 'Impression ID',
        category: TRACKING_LINK_CATEGORIES.OTHER,
        primary: false,
    },
    {
        singularKey: 'custom',
        fieldName: 'Partner Click ID',
        category: TRACKING_LINK_CATEGORIES.OTHER,
        primary: false,
    },
];

export const STANDARD_TRACKING_LINK_MAP = Object.fromEntries(
    STANDARD_TRACKING_LINK_PARAMETERS.map(p => [p.singularKey, p])
);

const INITIAL_GENERAL = {
    platform_template: '',
    receive_postbacks: true,
    platforms: [PLATFORMS.IOS, PLATFORMS.ANDROID],
    campaign_objectives: [CAMPAIGN_OBJECTIVES.INSTALLS, CAMPAIGN_OBJECTIVES.RE_ENGAGEMENTS],
};
const INITIAL_TRACKING_LINK_OPTIONS = {
    click_impression_reporting_method: CLICK_IMPRESSION_REPORTING_METHODS.CLIENT_SIDE,
    tracking_link_parameters: STANDARD_TRACKING_LINK_PARAMETERS.filter(p => p.primary).map(
        ({ singularKey, fieldName }) => ({
            singular_key: singularKey,
            field_name: fieldName,
            partner_macro: undefined,
        })
    ),
};
const INITIAL_POSTBACK_OVERALL_SETUP = {
    postback_events_and_platforms: [
        { event_type: POSTBACK_EVENT_TYPES.CONVERSIONS, platforms: [PLATFORMS.IOS, PLATFORMS.ANDROID] },
    ],
};
// Build the initial postback-templates map by seeding default macro rows for each
// (event_type, platform) combo declared in INITIAL_POSTBACK_OVERALL_SETUP. The user can delete
// any row from the templates tab; only new requests get this pre-population (existing requests
// pass `existingRequest.form_data` through verbatim).
const buildInitialPlatformTemplates = postbackMacroNetworkName => {
    const templates = {};
    INITIAL_POSTBACK_OVERALL_SETUP.postback_events_and_platforms.forEach(entry => {
        (entry.platforms || []).forEach(platform => {
            const defaults = getDefaultPostbackMacros(platform, entry.event_type, postbackMacroNetworkName);
            templates[entry.event_type] = {
                ...(templates[entry.event_type] || {}),
                [platform]: defaults.map(macro => ({ singular_macro: macro, partner_parameter_key: '' })),
            };
        });
    });
    return templates;
};

export const INITIAL_FORM_DATA = {
    [REQUEST_TYPES.ATTRIBUTION]: ({ postbackMacroNetworkName, isExistingRequest } = {}) => ({
        [ATTRIBUTION_TAB_IDS.GENERAL]: INITIAL_GENERAL,
        [ATTRIBUTION_TAB_IDS.TRACKING_LINK_OPTIONS]: INITIAL_TRACKING_LINK_OPTIONS,
        [ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP]: INITIAL_POSTBACK_OVERALL_SETUP,
        // New requests get default rows pre-populated; existing requests pass saved data through
        // verbatim (no auto-seeded defaults for combos the user didn't explicitly configure).
        [ATTRIBUTION_TAB_IDS.POSTBACK_TEMPLATES]: isExistingRequest
            ? {}
            : buildInitialPlatformTemplates(postbackMacroNetworkName),
    }),
};
